
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kBkBz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $7PLO8 = parcelRequire("7PLO8");


var $1aQ2R = parcelRequire("1aQ2R");


var $g6QPm = parcelRequire("g6QPm");


var $7zWPb = parcelRequire("7zWPb");

const $4e5fb2b69331c38d$export$ed4ec3024b990284 = (contentId)=>{
    const variables = (0, $g6QPm.createEditorContentUnifiedQueryVariables)({
        contentId: contentId,
        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
    });
    return (0, $7zWPb.withEditorContentFreshness)(variables, (fetchPolicy)=>(0, $dYU3e.query)({
            query: (0, $1aQ2R.default),
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "editor-content-unified-query"
        }));
};
module.exports["preloadEditorContentUnifiedQuery"] = $4e5fb2b69331c38d$export$ed4ec3024b990284;

});

parcelRegister("1aQ2R", function(module, exports) {
/**
 * @generated SignedSource<<4db36fa0ca2d8bb969395d44281a5283>>
 * @relayHash 5c7c2718af6b7d5952e45bbcbb0bc485
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e988ea1654568e1db8b7a2d9bc5c26cde2b53ae4df3b39c9385409f3100d66b1
const $6680153e74732958$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "draftShareId",
            "variableName": "draftShareId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "contentTypeModified"
        },
        {
            "kind": "ScalarField",
            "name": "number"
        },
        {
            "kind": "ScalarField",
            "name": "friendlyWhen"
        },
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentUnifiedQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useEditorContentTypesHeaderFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentTypesHeaderFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentUnifiedQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetType"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "alias": "smartFolderProperties",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "smartFolderProperties"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsonContentProperty",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "properties(keys:[\"smartFolderProperties\"])"
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5c7c2718af6b7d5952e45bbcbb0bc485",
            "id": "e988ea1654568e1db8b7a2d9bc5c26cde2b53ae4df3b39c9385409f3100d66b1",
            "metadata": {},
            "name": "EditorContentUnifiedQuery",
            "operationKind": "query",
            "text": "query EditorContentUnifiedQuery($contentId:ID!,$versionOverride:Int,$draftShareId:String,$status:[String]){content(id:$contentId,version:$versionOverride,draftShareId:$draftShareId,status:$status){nodes{...useEditorContentTypesHeaderFragment_content,id}}}fragment useEditorContentTypesHeaderFragment_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}"
        }
    };
}();
$6680153e74732958$var$node.hash = "2977c88a1bf5b58899795580b34293a6";
var $6680153e74732958$export$2e2bcd8739ae039 = $6680153e74732958$var$node;
module.exports["default"] = $6680153e74732958$export$2e2bcd8739ae039;

});

parcelRegister("7zWPb", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $1aQ2R = parcelRequire("1aQ2R");

const $043b772404268ab3$var$entries = new Map();
const $043b772404268ab3$var$EDITOR_CONTENT_TTL_MS = 15000;
// Module state on the server is shared across Bifrost requests, so every function is a no-op there.
function $043b772404268ab3$var$isSSR() {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined);
}
function $043b772404268ab3$var$getKey(contentId, draftShareId) {
    return `${contentId}:${draftShareId || ''}`;
}
function $043b772404268ab3$var$deleteEntry(key) {
    $043b772404268ab3$var$entries.get(key)?.retention?.dispose();
    $043b772404268ab3$var$entries.delete(key);
}
// Entries of pages the editor never showed (a warm-up without a click) are never cleared otherwise.
function $043b772404268ab3$var$deleteExpired() {
    const now = performance.now();
    for (const [key, { fetchedAt: fetchedAt }] of $043b772404268ab3$var$entries)if (now - fetchedAt > $043b772404268ab3$var$EDITOR_CONTENT_TTL_MS) $043b772404268ab3$var$deleteEntry(key);
}
// Nothing may read the operation until the editor mounts (e.g. after a hover), so it is retained
// from the start of the fetch; Relay can collect unretained data as soon as it is published.
// Same environment as `query` from query-preloader-tools executes on.
function $043b772404268ab3$var$retain(variables) {
    if ($043b772404268ab3$var$isSSR() || !window.GLOBAL_RELAY_ENV) return null;
    return window.GLOBAL_RELAY_ENV.retain((0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $1aQ2R.default)), variables));
}
function $043b772404268ab3$var$markFetched(key, retention) {
    $043b772404268ab3$var$deleteExpired();
    $043b772404268ab3$var$deleteEntry(key);
    $043b772404268ab3$var$entries.set(key, {
        fetchedAt: performance.now(),
        retention: retention
    });
}
function $043b772404268ab3$export$1f040fe4c1c6ec50(contentId, draftShareId) {
    if ($043b772404268ab3$var$isSSR()) return false;
    const entry = $043b772404268ab3$var$entries.get($043b772404268ab3$var$getKey(contentId, draftShareId));
    return entry !== undefined && performance.now() - entry.fetchedAt <= $043b772404268ab3$var$EDITOR_CONTENT_TTL_MS;
}
function $043b772404268ab3$export$c6247d4f21abc039(variables, runQuery) {
    const key = $043b772404268ab3$var$getKey(variables.contentId, variables.draftShareId);
    // Never fresh on SSR, so the server always fetches.
    const isFresh = $043b772404268ab3$export$1f040fe4c1c6ec50(variables.contentId, variables.draftShareId);
    // A store read is not new data, so it neither extends the TTL nor the retention.
    const retention = isFresh ? null : $043b772404268ab3$var$retain(variables);
    return runQuery(isFresh ? 'cache-first' : 'network-only').then((result)=>{
        if (!isFresh && !$043b772404268ab3$var$isSSR() && result.data?.content) $043b772404268ab3$var$markFetched(key, retention);
        else retention?.dispose();
        return result;
    }, (error)=>{
        retention?.dispose();
        throw error;
    });
}
function $043b772404268ab3$export$e8cd43e42adc5f39(contentId) {
    if ($043b772404268ab3$var$isSSR()) return;
    $043b772404268ab3$var$deleteExpired();
    const prefix = `${contentId}:`;
    for (const key of $043b772404268ab3$var$entries.keys())if (key.startsWith(prefix)) $043b772404268ab3$var$deleteEntry(key);
}
function $043b772404268ab3$export$c2dbddd61ca9a12c() {
    for (const key of $043b772404268ab3$var$entries.keys())$043b772404268ab3$var$deleteEntry(key);
}
module.exports["withEditorContentFreshness"] = $043b772404268ab3$export$c6247d4f21abc039;
module.exports["clearEditorContentFetched"] = $043b772404268ab3$export$e8cd43e42adc5f39;

});

parcelRegister("iZ7G7", function(module, exports) {
// Maximum number of JSON.parse iterations to apply to a stringified document.
// In practice the wire shape is at most double-encoded, so 3 iterations gives
// us headroom while still bounding the loop.
const $aa12c5a22e7258c3$var$MAX_DOCUMENT_DECODE_PASSES = 3;
const $aa12c5a22e7258c3$export$c237b35d986a7858 = (document)=>{
    if (document == null) return null;
    let candidate = document;
    for(let pass = 0; pass < $aa12c5a22e7258c3$var$MAX_DOCUMENT_DECODE_PASSES; pass++){
        if (typeof candidate !== 'string') break;
        try {
            candidate = JSON.parse(candidate);
        } catch  {
            return null;
        }
    }
    // Still a string after exhausting all decode passes, or resolved to a
    // non-object primitive (number, boolean, null, etc.) — give up.
    if (typeof candidate !== 'object' || candidate === null) return null;
    return candidate;
};
const $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult = new WeakMap();
const $aa12c5a22e7258c3$export$867137d201e5eab4 = (collabDraftResult)=>{
    if (!collabDraftResult || typeof collabDraftResult !== 'object') return null;
    if ($aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.has(collabDraftResult)) return $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.get(collabDraftResult) ?? null;
    const parsedAdf = $aa12c5a22e7258c3$export$c237b35d986a7858(collabDraftResult.data?.collabDraft?.document);
    $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.set(collabDraftResult, parsedAdf);
    return parsedAdf;
};
module.exports["decodeCollabDraftDocument"] = $aa12c5a22e7258c3$export$c237b35d986a7858;
module.exports["parseCollabDraftAdf"] = $aa12c5a22e7258c3$export$867137d201e5eab4;

});

parcelRegister("9OYfw", function(module, exports) {

var $iZ7G7 = parcelRequire("iZ7G7");


var $g6QPm = parcelRequire("g6QPm");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $l1kdf = parcelRequire("l1kdf");


var $nIvaQ = parcelRequire("nIvaQ");


var $8R0gj = parcelRequire("8R0gj");


var $hNtOj = parcelRequire("hNtOj");


var $27Dus = parcelRequire("27Dus");

function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "load-edit-page"
    }).then(async (result)=>{
        // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
        // that doesn't preserve the result in caches if there is an error in SSR
        // So we need to preserve the error, to be able to verify it later during render phase in SSR
        if (result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) {
            // Opening a draft share link grants the user SHARED permission on the BE, but parallel
            // requests can be evaluated before that permission is visible, so a denial here may be a
            // lost race rather than a real restriction. Let the collab connection (which carries the
            // draftShareId) decide instead; a real restriction surfaces as a 403 from NCS.
            const deferToCollabPermissionCheck = Boolean(draftShareId) && (0, $6mKj3.expValEquals)('cc_perms_fix_blog_draft_restricted_page_showing', 'isEnabled', true);
            if (!deferToCollabPermissionCheck) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
        }
        // There are two reasons to store smart card URLs on the window object:
        // 1. The OTP uses a document snapshot from Confluence that may be outdated and miss recently added or removed smart cards,
        //    so we must reconcile the list of smart cards with the draft content.
        // 2. The draft content stores links with slugs, but the Confluence snapshot does not,
        //    so we need to add slugs sourced from the draft content.
        // Therefore, we extract smart cards from the draft content here, save them on the window object,
        // and later use them to align the Confluence snapshot with the draft content.
        if ((0, $6mKj3.expValEquals)('cc-proj-xl-dedup-macro-preload-adf-parsing', 'isEnabled', true)) window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodesFromDoc)((0, $iZ7G7.parseCollabDraftAdf)(result));
        else window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodes)(result?.data?.collabDraft?.document || '');
        return result;
    });
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        query: (0, $l1kdf.NativeCollabQuery),
        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? (0, $g6QPm.createEditorContentUnifiedQueryVariables)({
            contentId: contentId,
            draftShareId: draftShareId,
            status: status
        }) : {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        },
        __callerPackage__: "load-edit-page"
    });
}
module.exports["preloadCollabDraftContent"] = $cb117090d47a4a62$export$952cf09a216eb6d;
module.exports["preloadNativeCollab"] = $cb117090d47a4a62$export$7c1f00ae06ab82b8;

});

parcelRegister("l1kdf", function(module, exports) {

var $hrBIS = parcelRequire("hrBIS");

const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $hrBIS.default);
module.exports["NativeCollabQuery"] = $c2e596865d8e6fea$export$79b924d780de6f0d;

});

parcelRegister("hrBIS", function(module, exports) {
/**
 * @generated SignedSource<<4cf4db12dd73f2ac885d741a3d7c65ba>>
 * @relayHash 4e152ff0861f20bc69927f68972ccc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc
const $83575f8369490c15$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "draftShareId",
            "variableName": "draftShareId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v12 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4e152ff0861f20bc69927f68972ccc1e",
            "id": "24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc",
            "metadata": {},
            "name": "NativeCollabQuery",
            "operationKind": "query",
            "text": "query NativeCollabQuery($contentId:ID,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,type,status,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},history{createdBy{__typename,displayName},createdDate},space{id,name,homepageId},labels{nodes{id,name}},subType}}}"
        }
    };
}();
$83575f8369490c15$var$node.hash = "182a5142c1846497c5e27245efe74033";
var $83575f8369490c15$export$2e2bcd8739ae039 = $83575f8369490c15$var$node;
module.exports["default"] = $83575f8369490c15$export$2e2bcd8739ae039;

});

parcelRegister("8R0gj", function(module, exports) {

var $747ya = parcelRequire("747ya");

async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        startTime: window?.performance?.now?.()
    };
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
module.exports["preloadDraft"] = $65899b702fdd32b1$export$dfd3c4c0aa957792;
module.exports["isDraftSSRPreloadPermissionError"] = $65899b702fdd32b1$export$9d45b1b64b2cb8e1;

});

parcelRegister("747ya", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $fqIt3 = parcelRequire("fqIt3");


var $nIvaQ = parcelRequire("nIvaQ");

async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    // Use cache-first only if SSR rendered AND cache is not stale (within TTL)
    // This prevents stale data during SPA transitions while still benefiting from SSR cache
    const shouldUseCache = window.__SSR_RENDERED__ || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId);
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: shouldUseCache ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-providers"
    });
    const { data: data, error: error } = response;
    if (error || !data?.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}
module.exports["fetchDraft"] = $67d2826966f59cb2$export$af6160a01d539948;

});

parcelRegister("27Dus", function(module, exports) {

var $eRwHS = parcelRequire("eRwHS");


var $gVWsk = parcelRequire("gVWsk");


var $6GQtz = parcelRequire("6GQtz");


var $aN0qB = parcelRequire("aN0qB");

function $010c1dfc98319256$export$4d8d014fcb52d0f(doc) {
    if (!(0, $gVWsk.isJSONDocNode)(doc)) return [];
    const cardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)('custom');
    return (0, $eRwHS.findNodesToPrefetch)(doc, [
        {
            provider: cardProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        }
    ], (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT))[0].nodes;
}
function $010c1dfc98319256$export$1970baffe86d32af(docJsonString) {
    if (!docJsonString) return [];
    return $010c1dfc98319256$export$4d8d014fcb52d0f(JSON.parse(docJsonString));
}
module.exports["findSmartCardNodesFromDoc"] = $010c1dfc98319256$export$4d8d014fcb52d0f;
module.exports["findSmartCardNodes"] = $010c1dfc98319256$export$1970baffe86d32af;

});

parcelRegister("eRwHS", function(module, exports) {
function $d135bda53bcecc47$export$41263783ff0932a8(doc, providers, maxNodesToVisit) {
    // Counter for the total number of visited nodes to limit the traversal.
    let totalVisitedNodesCount = 0;
    // A map to store the results, with the provider name as the key.
    const resultMap = providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            provider: provider,
            nodes: []
        };
        return acc;
    }, {});
    // It doesn't use `filter` function from `@atlaskit/adf-utils/traverse` because it does not support early stopping.
    // We need to stop traversing when we reach the maximum number of nodes to visit to support large documents.
    // Create a list of providers for which we still need to find nodes.
    const providersToLookup = providers.filter(({ maxNodesToPrefetch: maxNodesToPrefetch })=>maxNodesToPrefetch > 0).map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            foundNodes: 0
        }));
    // Stack for the depth-first search (DFS), starting with the root document node.
    const nodesToVisit = [
        doc
    ];
    // The loop continues as long as there are nodes to visit, providers to look for,
    // and the visited nodes limit has not been reached.
    while(nodesToVisit.length > 0 && providersToLookup.length > 0 && totalVisitedNodesCount < maxNodesToVisit){
        totalVisitedNodesCount += 1;
        // Pop from the end to maintain DFS order (LIFO - Last In, First Out)
        const currentNode = nodesToVisit.pop();
        if (!currentNode) continue;
        // Using a reverse loop to avoid issues with array mutation (when removing elements).
        for(let i = providersToLookup.length - 1; i >= 0; i--){
            const providerToFind = providersToLookup[i];
            // Check if the current provider supports this node.
            if (providerToFind.provider.isNodeSupported(currentNode)) {
                // If provider supports the node, add it to the result map.
                resultMap[providerToFind.provider.name].nodes.push(currentNode);
                // Increment the count of found nodes for this provider.
                providerToFind.foundNodes += 1;
                // If the provider has found enough nodes, remove it from the lookup list.
                if (providerToFind.foundNodes >= providerToFind.maxNodesToPrefetch) providersToLookup.splice(i, 1);
            }
        }
        // If the current node has children, add them to the stack in reverse order
        // to maintain left-to-right traversal when popping from the stack,
        // because it's LIFO.
        if (currentNode.content) // Push children in reverse order to maintain correct DFS traversal order
        for(let i = currentNode.content.length - 1; i >= 0; i--){
            const node = currentNode.content[i];
            if (node) nodesToVisit.push(node);
        }
    }
    // Return an array of the found nodes, grouped by provider.
    return Object.values(resultMap);
}
module.exports["findNodesToPrefetch"] = $d135bda53bcecc47$export$41263783ff0932a8;

});

parcelRegister("aN0qB", function(module, exports) {
// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
const $e5ce665804adc727$export$d723a039341399fc = 10000;
const $e5ce665804adc727$export$109b6787e4cb0d4c = {
    smartCard: 10,
    emoji: 500
};
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT"] = $e5ce665804adc727$export$d723a039341399fc;
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH"] = $e5ce665804adc727$export$109b6787e4cb0d4c;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("8KbKw", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $c0rhi = parcelRequire("c0rhi");


var $aMcHK = parcelRequire("aMcHK");


var $6fil2 = parcelRequire("6fil2");


var $lR7wI = parcelRequire("lR7wI");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$var$shouldRetryUnknownStatusNetworkError = (error)=>{
    const isNetworkError = (0, $6fil2.containsNetworkError)(error);
    const networkError = error?.networkError ?? error;
    const isCausedByAbortError = networkError instanceof (0, $6fil2.NetworkError) && (0, $6fil2.causedByAbortError)(networkError);
    const isOnline = typeof navigator === 'undefined' || navigator.onLine;
    const statusCode = (0, $aMcHK.getStatusCodeError)(error);
    return isNetworkError && !isCausedByAbortError && isOnline && statusCode === undefined;
};
const $6f395e426fb151a0$var$emitRetryCompleted = (outcome)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            action: 'retryCompleted',
            actionSubject: 'collabPermissionToken',
            source: 'fetchCollabPermissionToken',
            attributes: {
                outcome: outcome
            }
        });
    });
};
const $6f395e426fb151a0$var$getTokenFromQueryResult = (result)=>{
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
    const token = result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
    if (token === null && (0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            action: 'nullTokenReturned',
            actionSubject: 'collabPermissionToken',
            source: 'fetchCollabPermissionToken',
            attributes: {
                reason: 'emptyResponse'
            }
        });
    });
    return token;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $dOBRD.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        const query = ()=>(0, $c0rhi.queryInterop)({
                query: (0, $lR7wI.default),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                },
                __callerPackage__: "native-collab"
            });
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const result = await query();
            return $6f395e426fb151a0$var$getTokenFromQueryResult(result);
        } catch (e) {
            if ((0, $6mKj3.expVal)('platform_editor_retry_collab_token_query', 'isEnabled', false)) {
                if ($6f395e426fb151a0$var$shouldRetryUnknownStatusNetworkError(e)) try {
                    const result = await query();
                    const token = $6f395e426fb151a0$var$getTokenFromQueryResult(result);
                    $6f395e426fb151a0$var$emitRetryCompleted(token === null ? 'emptyResponse' : 'tokenReturned');
                    return token;
                } catch (retryError) {
                    $6f395e426fb151a0$var$emitRetryCompleted('fetchError');
                    e = retryError;
                }
            }
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            if ((0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) {
                const statusCode = (0, $aMcHK.getStatusCodeError)(e);
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        action: 'nullTokenReturned',
                        actionSubject: 'collabPermissionToken',
                        source: 'fetchCollabPermissionToken',
                        attributes: {
                            reason: 'fetchError',
                            statusCode: statusCode ?? 'unknown'
                        }
                    });
                });
            }
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("lR7wI", function(module, exports) {
/**
 * @generated SignedSource<<a61063136e57f7cd39e5b8a983d46e87>>
 * @relayHash bd2d61cdca16378a4f1f566700b1fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69
const $4abe7e20c4ebe0be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "CollabTokenResponse",
            "kind": "LinkedField",
            "name": "collabToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bd2d61cdca16378a4f1f566700b1fb56",
            "id": "5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69",
            "metadata": {},
            "name": "CollabPermissionTokenQuery",
            "operationKind": "query",
            "text": "query CollabPermissionTokenQuery($contentId:ID!,$draftShareId:String){collabToken(id:$contentId,draftShareId:$draftShareId){token}}"
        }
    };
}();
$4abe7e20c4ebe0be$var$node.hash = "f88c8dd0f4e61065305cc9c5b9a3253b";
var $4abe7e20c4ebe0be$export$2e2bcd8739ae039 = $4abe7e20c4ebe0be$var$node;
module.exports["default"] = $4abe7e20c4ebe0be$export$2e2bcd8739ae039;

});


//# sourceMappingURL=NativeCollabComponent.e5fa4cd4.js.map
